/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Tincture = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Tincture"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#8E00E5"
        d="M5.99 19.488c-3.32-3.35-3.32-8.78 0-12.13l4.812-4.856a1.68 1.68 0 0 1 2.396 0l4.812 4.856c3.32 3.35 3.32 8.78 0 12.13a8.446 8.446 0 0 1-12.02 0"
        className="Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        fillRule="evenodd"
        d="M6.9 14.235c.47 0 .85.386.85.863 0 1.43 1.142 2.588 2.55 2.588.47 0 .85.386.85.863s-.38.863-.85.863c-2.347 0-4.25-1.932-4.25-4.314 0-.477.38-.863.85-.863"
        className="Details"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const TinctureIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'tincture-icon'}
      icon={Tincture}
      {...props}
      size={size}
    />
  );
};
